import React, { useCallback, useMemo } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { cn } from '@shared/utils/lib/ui';

import { observer } from 'mobx-react-lite';
import { useMarginTradePanelStore } from 'src/lib/margin/hooks/trade';
import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

type Props = {
  url: NavigationURLs;
  pathParams?: object;
  title: string;
  dataTestId?: string;
};

const SwyftxMarginAppHeaderNavItem: React.FC<Props> = observer(({ url, title, pathParams, dataTestId }) => {
  const { isRouteActive, navigate } = useNavigateRoute();
  const { reset } = useMarginTradePanelStore();
  const isActive = useMemo(() => isRouteActive(url, { pathParams }), [isRouteActive, pathParams, url]);

  const navigateMarginRoute = useCallback(() => {
    if (isActive) return;

    navigate(url, { pathParams });
    reset();
  }, [isActive, navigate, pathParams, reset, url]);

  return (
    <FlexLayout spacing={12} justifyContent='center' alignItems='center' direction='column' className='h-full'>
      <Body
        onClick={navigateMarginRoute}
        weight='bold'
        className={cn(
          'cursor-pointer rounded-[8px] px-16 py-8 hover:text-color-text-primary',
          isActive ? 'bg-color-background-surface-active' : 'hover:bg-color-background-surface-hover',
        )}
        color={isActive ? 'primary' : 'secondary'}
        data-testid={dataTestId}
      >
        {title}
      </Body>
    </FlexLayout>
  );
});

export { SwyftxMarginAppHeaderNavItem };
